import { FBF_CloudCallable } from '@rabbit/firebase/adapter';
import { DocIdParamDto, CreateCategoryDto, UpdateCategoryDto, CategoryQueryDto } from '@rabbit/nest/api';
import { DTCategory_Public } from '@rabbit/data/types';

export const nestApiCreateCategory = FBF_CloudCallable<
  CreateCategoryDto,
  DTCategory_Public
>('api/category/create|POST');

export const nestApiUpdateCategory = FBF_CloudCallable<
  DocIdParamDto & UpdateCategoryDto,
  DTCategory_Public
>('api/category/:docid|PUT');

export const nestApiDeleteCategory = FBF_CloudCallable<
  DocIdParamDto,
  DTCategory_Public
>('api/category/:docid|DELETE');

export const nestApiGetCategory = FBF_CloudCallable<
  DocIdParamDto,
  DTCategory_Public
>('api/category/:docid|GET');

export const nestApiGetAllCategories = FBF_CloudCallable<
  CategoryQueryDto,
  DTCategory_Public[]
>('api/category|GET');